module.exports = __webpack_public_path__ + "media/fastweb_volunteers/fw-gently-used-prom-outfit-710b77f9.png";